import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import { Input } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import type RoadCreateViewModel from "viewModels/timeCharges/distributorEnums/roads/roadCreateViewModel";
import type RoadDetailViewModel from "viewModels/timeCharges/distributorEnums/roads/roadDetailViewModel";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";

export interface RoadFormProps {
  vm: RoadCreateViewModel | RoadDetailViewModel;
  children?: React.ReactNode;
}

const RoadForm = observer((props: RoadFormProps) => {
  const { vm, children } = props;
  const disabled = !vm.isEditable;

  return (
    <>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="name">
          <FormLabel>{vm.translateAttribute("name")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} target={vm.item} property="roadType">
          <FormLabel>{vm.translateAttribute("roadType")}</FormLabel>
          <AdvancedSelect items={vm.roadTypes} disabled={disabled} />
        </FormGroup>
      </Form.Row>
      {children}
    </>
  );
});

export default RoadForm;
